export default __webpack_public_path__ + "static/media/hairdresser.cc664546.svg";